export default __webpack_public_path__ + "static/media/IMG-20241005-WA0016.dc8bcc51.jpg";